<template>
	<components :is="compName" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { Icon } from "ant-design-vue";
import DiyIcon from "./DiyIcon.vue";
export default {
	name: "YwIcon",
	inheritAttrs: false,
	components: { Icon, DiyIcon },
	data() {
		return {
			node: null,
		};
	},
	computed: {
		// 判断是否是自定义图标
		compName() {
			let iconName = null;
			if (this.$attrs.type) {
				iconName = "Icon";
			}
			if (this.$attrs.iconClass) {
				iconName = "DiyIcon";
			}
			return iconName;
		},
	},
	mounted() {},
};
</script>
